const styles = {
  "switch": "_switch_on91c_1"
};
export {
  styles as default
};
//# sourceMappingURL=Switch.module.scss.js.map
